// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";
import * as GatsbyLink from "gatsby-link";
import * as TypographyJs from "../utils/typography.js";

function rhythm(prim) {
  return TypographyJs.rhythm(prim);
}

function scale(prim) {
  return TypographyJs.scale(prim);
}

function Layout(Props) {
  var $$location = Props.location;
  var title = Props.title;
  var children = Props.children;
  var rootPath = __PATH_PREFIX__ + "/";
  var header = $$location.pathname === rootPath ? React.createElement("h1", {
          style: {
            fontSize: TypographyJs.scale(1.5).fontSize,
            lineHeight: TypographyJs.scale(1.5).lineHeight,
            marginTop: "0",
            marginBottom: TypographyJs.rhythm(1.5)
          }
        }, React.createElement(GatsbyLink.default, {
              to: "/",
              style: {
                color: "inherit",
                textDecoration: "none",
                boxShadow: "none"
              },
              children: title
            })) : React.createElement("h3", {
          style: {
            fontFamily: "Montserrat, sans-serif",
            marginTop: "0"
          }
        }, React.createElement(GatsbyLink.default, {
              to: "/",
              style: {
                color: "inherit",
                textDecoration: "none",
                boxShadow: "none"
              },
              children: title
            }));
  return React.createElement("div", {
              style: {
                marginRight: "auto",
                marginLeft: "auto",
                maxWidth: TypographyJs.rhythm(24),
                padding: TypographyJs.rhythm(1.5) + (" " + TypographyJs.rhythm(0.75))
              }
            }, React.createElement("header", undefined, header), React.createElement("main", undefined, children), React.createElement("footer", undefined, "Built with ", React.createElement("a", {
                      href: "https://www.gatsbyjs.org"
                    }, "Gatsby")));
}

Layout.displayName = "Layout";

var Link = /* alias */0;

var make = Layout;

var $$default = Layout;

export {
  Link ,
  rhythm ,
  scale ,
  make ,
  $$default ,
  $$default as default,
  
}
/*  Not a pure module */
